<template>
  <!-- <div class="content-wrappper"> -->
    <div class="col-xs-12 p-0 dashboard-container">
      <div class="col-xs-12 header-wrapper">
        <div class="d-flex flex-between mb-20">
          <div class="fw-400 header-text custom-tooltip-record" :class="{'tooltip-left':this.$i18n.locale === 'Portuguese'}">{{ $t('certificates') }}
            <!-- <img  src="/static/images/icons/info_icon_reg_details.svg" class="hide_xs  cursor-pointer" alt=""  :title="$t('complianceTrackerFooterText')"/> -->
            <excel-info-popover :info="this.$i18n.locale === 'English'?tooltipObject.tooltip:tooltipObjectPortuguese.tooltip"></excel-info-popover>
          </div>

          <div class="d-flex col-gap-10 align-items-center">
            <button :disabled="searchResultCount <= 0" class="btn archive-btn d-flex col-gap-8 align-items-center" @click="downloadRecords">
              <img src="/static/images/icons/DownloadTemplate.svg" class="download-btn-plus-icon" alt="plus-icon" />
              <span>{{ $t('download')}}</span>
            </button>
            <template v-if="permissions.indexOf('ARCHIEVE_A_REGISTRATION') > -1 && !archivedFlag && tabName !== 'Draft' && tabName !== 'Invalid Records'">
              <button
                :disabled="selectedRegistration.length <= 1"
                @click="confirmArchiveRegistrations"
                class="btn archive-btn d-flex col-gap-8 align-items-center"
              >
                <img src="/static/images/icons/emergo_archive.svg" alt="archive icon" />
                <span>{{ $t('archive') }}</span>
              </button>
            </template>
            <template v-if="permissions.indexOf('UNARCHIEVE_A_REGISTRATION') > -1 && archivedFlag">
              <button
                :disabled="selectedRegistration.length <= 1"
                @click="confirmArchiveRegistrations"
                class="btn archive-btn d-flex col-gap-8 align-items-center"
              >
                <img src="/static/images/icons/emergo_unarchive.svg" alt="archive icon" />
                {{ $t('unarchive') }}
              </button>
            </template>
            <template v-if="permissions.indexOf('DELETE_A_REGISTRATION') > -1">
              <button
                :disabled="selectedRegistration.length <= 1"
                @click="confirmDeleteRegistrations"
                class="btn delete-btn d-flex col-gap-8 align-items-center"
              >
                <img src="/static/images/icons/emergo_delete.svg" alt="delete icon" />
                <span>{{ $t('delete') }}</span>
              </button>
            </template>
            <template v-if="roleId === 1 || roleId === 2" >
              <button
                @click="showBulkUploadPopup"
                class="btn archive-btn d-flex col-gap-8 align-items-center"
              >
                <img src="/static/images/icons/bulkUpload.svg" alt="archive icon" />
                {{ $t('bulkUpload') }}
              </button>
            </template>
            <button
              @click="goToAddRecord"
              v-if="permissions.indexOf('ADD_A_RECORD') > -1"
              :disabled="
                enableRecordLoader || importProgressStatus || disableAdd
              "
              class="btn emergo-btn emergo-primary-button d-flex col-gap-10 align-items-center"
            >
              <img src="/static/images/icons/add_icon.svg" alt="" />
              <span>{{ $t('add') }}
                <span class="xs-hide">{{ $t('certificate') }}</span>
              </span>
            </button>
          </div>
        </div>
        <div class="col-xs-12 p-0 p-relative">
          <tab-with-search
            :searchResultCount="searchResultCount"
            v-model="registrationSearch"
            @setSelectedTab="regMenuSelected"
            :activeTab="regHeaderActiveName"
            :tabsList="totalRecordCountDetails"
            :roleInfo="roleInfo"
            :roleId="roleId"
            @input="setSearch"
            @setShowFilter="isFilterSelected = !isFilterSelected"
          ></tab-with-search>
          <new-filter
            :permissions="permissions"
            :dateFormat="dateFormat"
            :types="types"
            :countriesList="countryListFilter"
            :selectedColumns="diffSelectedColumns"
            :showFilter="isFilterSelected"
            :filtersList="filtersList"
            :expectedFilter="resultingFilter"
            :availableColumns="gridColumns"
            @setSelectedColumns="setSelectedColumnsList"
            @setFilter="filteredOptions"
            @setShowFilter="isFilterSelected = !isFilterSelected"
          ></new-filter>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 section-wrapper">
        <registration-data-grid
          :threeDotsPermissionFlag="threeDotsPermissionFlag"
          :permissions="permissions"
          :enableCheckAll="enableCheckAll"
          :roleId="roleId"
          :disableContent="disableContent || importProgressStatus"
          :activeId="activeId"
          :countryCertificateType="countryCertificateType"
          :refreshDataAfterDeleteRecord="refreshDataAfterDeleteRecord"
          :loadingStatus="importProgressStatus"
          :data="gridDataList"
          :columns="selectedColumns"
          :filter-key="filterKey"
          :openRegistrationId="openRegistrationId"
          :selectedRegistrationList="selectedRegistration"
          :archivedFlag="archivedFlag"
          @selectedRegistrationListChanged="selectedRegistrationListChanged"
          @selectedRegistrationListDeleted="selectedRegistrationListDeleted"
          @setSearch="setSearch"
          @archiveRegistrationOnSelect="archiveRegistrationOnSelect"
          @deleteRegistrationOnSelect="deleteRegistrationOnSelect"
          @exportRegistrationOnSelect="exportRegistrationOnSelect"
          :exportStatus="exportStatus"
          @shareEmailLinkOnSelect="shareEmailLinkOnSelect"
          :expiryDateFormate="expiryDateFormate"
          :registrationSearch="registrationSearch"
          @filteredRegistrationsLength="filteredRegistrationsLength"
          ref="registrationGrid"
          @viewHistoryOnSelect="viewHistoryOnSelect"
          :tableLoader="tableLoader"
          :totalRecordsData="totalRecordsData"
          :roleInfo="roleInfo"
        ></registration-data-grid>
        <div class="bn-pagination col-xs-12 p-0" v-if="totalPages > 1">
          <pagination :totalPages="totalPages" :maxVisibleButtons="maxVisiblePages" :total="total" :perPage="perPage"
        :currentPage="currentPage" @pagechanged="pageChanged" :skipToFirst=true :skipToLast=true></pagination>
      </div>
      </div>
      <div class="clearfix"></div>
      <loader :loadingStatus="loaderStatus"></loader>
      <delete-registration
        :data="selectedAndFilteredRecords"
        :max_records_delete="max_records_delete"
        :roleId="roleId"
        :recordType="filterKey"
        @loadRegistrationDataAfterDelete="loadRegistrationDataAfterDelete"
        @loadRegistrationDataAfterCancel="loadRegistrationDataAfterCancel"
        @loadInvalidRecords="loadInvalidRecords"
      ></delete-registration>
      <archive-registration
        :data="selectedAndFilteredRecords"
        :roleId="roleId"
        :archivedFlag="archivedFlag"
        :selectedArchiveReason="selectedArchiveReason"
        @loadRegistrationDataafterArchive="loadRegistrationDataafterArchive"
        @loadRegistrationDataAfterCancel="loadRegistrationDataAfterCancel"
      ></archive-registration>
      <progress-bar
        :progressStatus="progressStatus"
        :percentage="percentage"
        @updateProgressStatus="updateProgressStatus"
      ></progress-bar>
      <import-progress-bar
        :mode="mode"
        :progressStatus="importProgressStatus"
        :percentage="importPercentage"
        @updateImportProgressStatus="updateImportProgressStatus"
      ></import-progress-bar>
      <email-share-link
        :meta="emailPopupMeta"
        :data="emailPopupData"
        :relatedCertificates="emailPopupRelatedCertificates"
        @deleteMetaData="deleteMetaData"
      ></email-share-link>
      <view-history :historyData="historyData"></view-history>
      <record-type-popup @proceedAdd="proceedAdd" ></record-type-popup>
      <bulk-upload-popup @uploadRecords="uploadRecords"></bulk-upload-popup>
      <invalid-records-popup :successRecords=recordStatus.successfulRecords :invalidRecords=recordStatus.errorRecords @showInvalidRecordTab="showInvalidRecordTab"></invalid-records-popup>
      <subscription-popup from="complianceTracker"></subscription-popup>
      <confirmation-popup :title="confirmTitle" :confirmationText="confirmationText"></confirmation-popup>
      <confirm-popup :title="confirmTitle" :confirmationText="confirmationText"></confirm-popup>
    </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { debounce, isEqual } from 'lodash';
import * as moment from 'moment';
import CloneDeep from 'clone-deep';
import FileSaver from 'file-saver';
import TabWithSearch from './complianceDashboard/TabWithSearch.vue';
import NewFilter from '../UIComponents/NewFilter.vue';
import SharedLeftFilter from '../UIComponents/SharedLeftFilter.vue';
import RightFilter from '../UIComponents/RightFilter.vue';
import DeleteRegistration from './RegistrationDelete.vue';
import ArchiveRegistration from './RegistrationArchive.vue';
import ViewHistory from './ViewHistory.vue';
import RecordTypePopup from './RecordTypePopup.vue';
import bulkUploadPopup from './BulkUploadPopup.vue';
import invalidRecordsPopup from './InvalidRecordPopup.vue';
import SubscriptionPopup from './SubscriptionPopup.vue';
import RegistrationDataGrid from './RegistrationDataGrid.vue';
import Pagination from '../SuperAdmin/Pagination.vue';
import Loader from '../UIComponents/Loader.vue';
import ProgressBar from '../UIComponents/ProgressBar.vue';
import ImportProgressBar from '../UIComponents/ImportProgressBar.vue';
import SearchBox from '../UIComponents/SearchBox.vue';
import EventBus from '../../utils/event-bus';
import EmailShareLink from './EmailShareLink.vue';
import RegistrationFacetedFilter from './RegistrationFacetedFilter.vue';
import { getAllCountries } from '../../apis/countriesList';
import { getUserPreference, updateUserPreference } from '../../apis/profile';
import RegistrationHeaderTab from './RegistrationHeaderTab.vue';
import {
  getCountryCertificateAuth,
  getArchivingReasons,
  getRegistrationHistory,
  getProductsAvailable,
  getSubscriptions,
  getRegistrationDetailsByPagination,
  downloadRegistrationRecords
} from '../../apis/registrations';
import { getInvalidRecords } from '../../apis/BulkUpload';
import b64toBlob from '../../utils/base64toBlob';
import getDateRange from '../UIComponents/mixins/dateRangeSelectionMixin';
import { getDashboardSummary } from '../../apis/dashboard';
import ConfirmationPopup from '../Common/ULConfirmationPopup.vue';
import ExcelInfoPopover from '../UIComponents/ExcelInfoPopover.vue';
import ConfirmPopup from '../Common/ConfirmationPopup.vue';

export default {
  components: {
    NewFilter,
    TabWithSearch,
    RegistrationHeaderTab,
    ViewHistory,
    RecordTypePopup,
    SubscriptionPopup,
    DeleteRegistration,
    ArchiveRegistration,
    RegistrationDataGrid,
    Loader,
    ProgressBar,
    ImportProgressBar,
    EmailShareLink,
    RegistrationFacetedFilter,
    RightFilter,
    SearchBox,
    SharedLeftFilter,
    ConfirmationPopup,
    ExcelInfoPopover,
    bulkUploadPopup,
    invalidRecordsPopup,
    ConfirmPopup,
    Pagination
  },
  props: {
    regFilterPermissisonFlag: Boolean,
    threeDotsPermissionFlag: Boolean,
    permissions: Array,
    roleId: Number,
    openRegistration: String,
    searchRegistration: String,
    totalRecordCountDetails: Array,
    roleInfo: Object,
    complianceQuery: String,
  },
  mixins: [getDateRange],
  data() {
    return {
      tabName: '',
      isFilterSelected: false,
      tableLoader: false,
      historyData: [],
      chevronList: {
        // isDateChevron: 'Approval date',
        isExpiryDateChevron: 'Expiration Date',
        isCountryChevron: 'Country'
      },
      filtersList: ['columnOptions', 'expirationDate', 'countryOfOrigin'],
      types: {
        label: 'records',
        countryId: 'id',
        countryName: 'name'
      },
      dateFormat: 'YYYY-MM-DD',
      resultingFilter: {
        dateRange: {},
        expirationDates: {},
        countriesList: [],
        attachment: false,
        regulatoryAlert: false,
        isFilterSelected: false
      },
      complianceFilter: {
        dateRange: {},
        expirationDates: {},
        countriesList: [],
        attachment: false,
        regulatoryAlert: false,
        isFilterSelected: false
      },
      selectedAndFilteredRecords: [],
      exportRecords: [],
      regHeaderActiveName: '',
      filterObject: { flags: {} },
      tempSelectedRegistration: [],
      gridDataArchivedAndNonArchived: [], // when user clicks on clear in Arhive tab need to show All the records
      countryListFilter: [],
      countriesEffectedByRegAlert: [],
      gridDataList: [],
      activeId: new Set(),
      countryCertificateType: [],
      certificateCountryManual: [],
      mode: 'registrations',
      percentage: 0,
      importPercentage: 0,
      loaderStatus: false,
      progressStatus: false,
      importProgressStatus: false,
      selectedRegistration: [],
      gridColumns: [],
      registrationSearch: '',
      selectedColumns: [],
      diffSelectedColumns: [],
      gridData: [],
      gridDataNonArchived: [],
      gridDataArchived: [],
      invalidList: [],
      searchResultCount: 0,
      filteredRegistrationsCount: 0,
      archivedFlag: false,
      errors: [],
      disableContent: false,
      refreshDataAfterDelete: false,
      refreshDataAfterDeleteRecord: false,
      loadApi: false,
      modalStart: '',
      openRegistrationId: '',
      archiveReasonsList: [],
      selectedArchiveReason: [],
      gridDataProgress: [],
      showHelp: false,
      enableRecordLoader: false,
      girdChunkData: [],
      loadAfterSubmit: false,
      exportStatus: false,
      selectedExport: '',
      emailPopupData: {},
      emailPopupRelatedCertificates: [],
      emailPopupMeta: {},
      expiryDateFormate: '',
      certificateCountryList: [],
      enableCheckAll: false,
      upgradeRecords: {
        upgradeService: {},
        recordAddonService: null,
        teamAddonServices: null
      },
      disableAdd: false,
      max_records_delete: 50,
      isSelectedColumnsChanged: false,
      compliance: false,
      totalRecordsData: [],
      productsAvailable: {},
      subscriptions: [],
      recordStatus: {
        successfulRecords: 0,
        errorRecords: 0
      },
      total: 0,
      perPage: 100,
      totalPages: 1,
      maxVisiblePages: 4,
      currentPage: 1,
      statusId: [],
      isSaveDraft: false,
      isArchived: false,
      startDate: null,
      endDate: null,
      countryName: [],
      filterKey: 'View All',
      tooltipObject: { tooltip: 'DISCLAIMER; The Platform does not transmit conformity assessment documentation to INMETRO and User is solely responsible for directly filing all conformity assessment documentation with INMETRO in order to declare self-conformity with INMETRO requirements. The Platform does not guarantee the granting of the certification by INMETRO, neither does it grant the conformity status in Brazil.' },
      tooltipObjectPortuguese: { tooltip: 'AVISO LEGAL; A plataforma não transmite a documentação de avaliação de conformidade ao INMETRO e o Usuário é o único responsável por enviar diretamente toda a documentação de avaliação de conformidade ao INMETRO, a fim de declarar a autoconformidade com os requisitos do INMETRO. A Plataforma não garante a concessão da certificação pelo INMETRO, nem concede o status de conformidade no Brasil.' },
      confirmTitle: this.$i18n.locale === 'Portuguese' ? 'Renovar inscrição' : 'Renew Subscription',
      confirmationText:
        this.$i18n.locale === 'Portuguese'
          ? 'Por favor, renove sua assinatura para aproveitar os serviços PRO.'
          : 'Please renew your subscription to avail PRO services.'
    };
  },
  watch: {
    gridData: {
      deep: true,
      handler() {
        this.gridDataFunction();
      }
    },
    archivedFlag() {
      this.refreshDataAfterDelete = !this.refreshDataAfterDelete;
    },
    openRegistration: {
      immediate: true,
      handler(newVal) {
        if (newVal !== undefined) {
          this.openRegistrationId = newVal;
        }
      }
    },
    searchRegistration: {
      immediate: true,
      handler(newVal) {
        if (newVal !== undefined) {
          this.registrationSearch = newVal;
        }
      }
    },
    isSelectedColumnsChanged() {
      if (this.isSelectedColumnsChanged) {
        this.updateUserSelctedPreferences();
      }
    }
  },
  methods: {
    loadInvalidRecords() {
      this.filterRegistration(this.filterKey);
    },
    uploadRecords(response, type) {
      if (type === 'success') {
        if (this.filterKey === 'Invalid Records') {
          this.showInvalidRecordTab(this.filterKey);
        } else this.loadRegistrationDataafterAdd();
      }
      if (response && type === 'invalid') {
        this.recordStatus.successfulRecords = response.successful_records;
        this.recordStatus.errorRecords = response.error_records;
        $('#invalidRecordsPopup').modal('show');
      } else if (type === 'error') {
        this.confirmTitle = this.$i18n.locale === 'Portuguese' ? 'Arquivo inválido' : 'Invalid file';
        this.confirmationText = response.message;
        $('#confirmPopup').modal('show');
      }
    },
    showBulkUploadPopup() {
      $('#bulkUploadPopup').modal('show');
    },
    async showInvalidRecordTab(tab) {
      this.regMenuSelected(tab);
    },
    async proceedAdd(type) {
      this.getProducts(type);
    },
    async getProducts(type) {
      const response = await getProductsAvailable();
      this.productsAvailable = response.data.productsLeft;
      this.checkForProducts(type);
    },
    // triggerSubScriptionPopup() {
    //   EventBus.$on('subscriptionPopupTrigger', () => {
    //     $('#subscriptionPopup').modal({
    //       backdrop: 'static',
    //       keyboard: false
    //     });
    //   });
    // },
    checkForProducts(type) {
      if (type === 'false' || type === false) {
        this.$router.push({ path: '/layout/registration/add-record', query: { type } });
      } else if (this.productsAvailable) {
        this.$router.push({ path: '/layout/registration/flow/add-record', query: { type } });
      } else if (
        this.subscriptions.filter((obj) => obj.subscriptionId === 2).length > 0 &&
        this.subscriptions.filter((obj) => obj.subscriptionId === 2)[0].isActive === false
      ) {
        $('#deleteRecord').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        $('#subscriptionPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    },
    async downloadRecords() {
      const res = await downloadRegistrationRecords();
      const blob = b64toBlob(
        res.content,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      );
      FileSaver.saveAs(blob, res.title);
    },
    async pageChanged(currentPage) {
      if (currentPage) this.currentPage = currentPage;
      this.$emit('checkFalse', 0);
      await this.filterRegistration(this.filterKey);
    },
    goToAddRecord() {
      $('#addRecordPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    setSelectedColumnsList(userSelectedColumns) {
      this.selectedColumns = [...userSelectedColumns];
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    filterObj(object) {
      this.filterObject = object;
    },

    // validate selected and filtered records to archive/delete/export
    validateFilterAndGridDataMultiple() {
      const selectedRecordIds = [];
      this.selectedAndFilteredRecords = [];
      if (
        this.filterObject.flags.attachment ||
        this.filterObject.flags.expirey_date ||
        this.filterObject.flags.approval_date ||
        this.filterObject.flags.regulatory_alert ||
        this.filterObject.flags.country
      ) {
        // filter applied
        this.selectedRegistration.forEach((record) => {
          selectedRecordIds.push(record.registrationId);
        });
        this.gridDataList.forEach((record) => {
          if (selectedRecordIds.includes(record.registrationId)) {
            this.selectedAndFilteredRecords.push(record);
          }
        });
      } else {
        // selected records
        this.selectedAndFilteredRecords = [...this.selectedRegistration];
      }
    },

    regMenuSelected(selectedTab) {
      this.tabName = selectedTab;
      console.log((this.tabName));
      localStorage.setItem('tabSelected', this.tabName);
      this.filterRegistration(selectedTab);
    },
    loadRegistrationDataAfterCancel() {
      this.validateFilterAndGridDataMultiple();
    },
    async getCountryList() {
      const countryListStorage = await getAllCountries();
      this.countryListFilter = [];
      countryListStorage.forEach((data) => {
        this.countryListFilter.push({
          id: data.id,
          code: data.country_code,
          name: data.country_name
        });
      });
    },
    gridDataFunction() {
      // slice helps to create new list w/o referring
      this.gridDataList = this.gridData.slice();
      // this.filterObjectData(this.filterObject);
    },

    async filteredOptions(filter) {
      this.statusId = [1, 2, 3, 4];
      this.countryName = Object.values(filter.countriesList);
      this.startDate = filter.expirationDates.from;
      this.endDate = filter.expirationDates.to;
      await this.filterRegistration(this.filterKey);
      const isApprovalDateSelected = !!Object.keys(filter.dateRange).length;
      const isExpirationDateSelected = !!Object.keys(filter.expirationDates).length;
      const response = {
        flags: {
          attachment: filter.attachment,
          regulatory_alert: filter.regulatoryAlert,
          country: !!filter.countriesList.length,
          approval_date: isApprovalDateSelected,
          expirey_date: isExpirationDateSelected
        }
      };
      if (isApprovalDateSelected) {
        response.approval_date = {
          startApprovalDate: filter.dateRange.from,
          endApprovalDate: filter.dateRange.to
        };
      }
      if (isExpirationDateSelected) {
        response.expirey_date = {
          startExpireyDate: filter.expirationDates.from,
          endExpireyDate: filter.expirationDates.to
        };
      }
      if (filter.countriesList.length) response.countries = filter.countriesList;
      this.filterObjectData(response);
      // if (filter.fromCompliance) {
      //   EventBus.$emit('updateFilter1', filter.range);
      // }
    },
    filterObjectData(data) {
      this.filterObject = data;
      const gridDataObjects = {};
      const gridList = [];
      this.gridData.forEach((obj) => {
        let childExistsFlag = true; // not to execute further conditions when higher fails
        if (data.flags.attachment) {
          if (obj.attachmentLinks !== '' && obj.attachmentLinks != null && obj.attachmentLinks.length > 0) {
            gridDataObjects[obj.registrationId] = obj;
            gridList.push(obj.registrationId);
          } else {
            // if further conditions satisifies and not to push the data
            childExistsFlag = false;
          }
        }
        if (data.flags.expirey_date && childExistsFlag) {
          if (
            obj['Expiration Date'] != null &&
            moment(obj['Expiration Date']).format('YYYY-MM-DD') >=
              moment(data.expirey_date.startExpireyDate).format('YYYY-MM-DD') &&
            moment(obj['Expiration Date']).format('YYYY-MM-DD') <=
              moment(data.expirey_date.endExpireyDate).format('YYYY-MM-DD')
          ) {
            let flag = false;
            if (gridList.includes(obj.registrationId)) {
              flag = true;
            }
            if (!flag) {
              gridDataObjects[obj.registrationId] = obj;
              gridList.push(obj.registrationId);
            }
          } else {
            // AND condition so if not satisifying then remove from list
            childExistsFlag = false;
            delete gridDataObjects[obj.registrationId];
          }
        }
        if (data.flags.approval_date && childExistsFlag) {
          if (
            obj['Approval date'] != null &&
            moment(obj['Approval date']).format('YYYY-MM-DD') >=
              moment(data.approval_date.startApprovalDate).format('YYYY-MM-DD') &&
            moment(obj['Approval date']).format('YYYY-MM-DD') <=
              moment(data.approval_date.endApprovalDate).format('YYYY-MM-DD')
          ) {
            let flag = false;
            if (gridList.includes(obj.registrationId)) {
              flag = true;
            }
            if (!flag) {
              gridDataObjects[obj.registrationId] = obj;
              gridList.push(obj.registrationId);
            }
          } else {
            // AND condition so if not satisifying then remove from list
            childExistsFlag = false;
            delete gridDataObjects[obj.registrationId];
          }
        }
        if (data.flags.regulatory_alert && childExistsFlag) {
          if (this.countriesEffectedByRegAlert.length > 0 && this.countriesEffectedByRegAlert.includes(obj.countryId)) {
            let flag = false;
            if (gridList.includes(obj.registrationId)) {
              flag = true;
            }
            if (!flag) {
              gridDataObjects[obj.registrationId] = obj;
              gridList.push(obj.registrationId);
            }
          } else {
            // AND condition so if not satisifying then remove from list
            childExistsFlag = false;
            delete gridDataObjects[obj.registrationId];
          }
        }
        if (data.flags.country && childExistsFlag) {
          if (obj.countryId !== '' && data.countries.length && data.countries.indexOf(obj.countryId) > -1) {
            let flag = false;
            if (gridList.includes(obj.registrationId)) {
              flag = true;
            }
            if (!flag) {
              gridDataObjects[obj.registrationId] = obj;
              gridList.push(obj.registrationId);
            }
          } else {
            // AND condition so if not satisifying then remove from list
            childExistsFlag = false;
            delete gridDataObjects[obj.registrationId];
          }
        }
      });
      if (data.flags && Object.values(data.flags).some((el) => el)) {
        this.gridDataList.splice(0, this.gridDataList.length); // remove existing data
      } else {
        this.gridDataList = this.gridData.slice(); // Add all data
      }
      gridList.forEach((id) => {
        if (gridDataObjects[id] !== undefined) {
          this.gridDataList.push(gridDataObjects[id]); // Add filtered data
        }
      });
      this.validateFilterAndGridDataMultiple();
    },
    // remove metadata on close of sharelink popup
    deleteMetaData() {
      this.emailPopupMeta = {};
      this.emailPopupData = {};
    },
    // share emailLink
    shareEmailLinkOnSelect(metaObject, registrationObj) {
      this.emailPopupMeta = metaObject;
      this.emailPopupData = registrationObj;
      $('#registrationShareEmailLink').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    // export selected Registration
    async exportRegistrationOnSelect(exportObject) {
      this.selectedAndFilteredRecords = [];
      this.$set(this, 'selectedAndFilteredRecords', [exportObject.registrationObj]);
      if (exportObject.all) {
        this.selectedExport = 'all';
      } else this.selectedExport = 'selected';
      this.exportStatus = true;
      this.exportRecords = [exportObject.registrationObj];
      await this.$nextTick();
      $('#exportRecords').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    resetExportPopup() {
      this.selectedExport = '';
      this.exportRecords = [];
      this.$set(this, 'selectedAndFilteredRecords', []);
      this.$refs.registrationGrid.deselectAll();
    },
    async viewHistoryOnSelect(regId) {
      const data = await getRegistrationHistory(regId);
      this.historyData = data.body;
      $('#registrationHistory').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    // Delete selected Registration
    deleteRegistrationOnSelect(registrationObj) {
      this.selectedAndFilteredRecords = [];
      this.selectedAndFilteredRecords.push(registrationObj);
      $('#registrationDelete').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    // Archive selected Registration
    archiveRegistrationOnSelect(registrationObj) {
      this.selectedAndFilteredRecords = [];
      this.selectedAndFilteredRecords.push(registrationObj);
      $('#registrationArchive').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    updateProgressStatus() {
      this.progressStatus = false;
      this.showHelp = false;
    },

    updateImportProgressStatus() {
      this.importProgressStatus = false;
      this.importPercentage = 0;
    },
    // eslint-disable-next-line func-names
    setSearch: debounce(async function (value) {
      this.registrationSearch = value;
      this.$emit('search', this.searchKeyword);
      await this.filterRegistration(this.filterKey);
    }, 500),

    async loadColumnPreferences() {
      let gridColumns = [];
      axios.all([getUserPreference(), getCountryCertificateAuth(), getArchivingReasons()]).then(
        axios.spread((userPreference, countryCertificateAuth, archivingReasons) => {
          if (userPreference) {
            Object.keys(userPreference).forEach((key) => {
              if (
                key === 'product' ||
                key === 'barcode' ||
                key === 'submissionNumber' ||
                key === 'country' ||
                key === 'localRepresentative' ||
                key === 'expiration'
              ) {
                userPreference[key] = true;
              } else if (
                key !== 'expiry_date_format' &&
                key !== 'dashboardFirstCountry' &&
                key !== 'dashboardSecondCountry' &&
                key !== 'default_page_display'
              ) {
                userPreference[key] = false;
              }
            });
            this.expiryDateFormate = userPreference.expiry_date_format;
            Object.keys(userPreference).forEach((key) => {
              gridColumns = [
                'Manufacturer',
                'Product name',
                'Product category',
                'Model name',
                'Accredited by',
                'Barcode',
                'Certification URL',
                'Country of origin',
                'Status',
                'Expiration',
                'Approval date',
                'Maintenance date',
                'Next maintenance date',
                'Managed by',
                'Brand name',
                'Product class',
                'Certification number',
                'Comments',
                'Archive reason',
                'Description',
                'Standards',
                'Ordinance',
                'Imported Product',
                'Importer',
                'Requester',
                'Trade Representative',
                'Input Status',
                'Test Report Attachments',
                'Product Certificate Attachments',
                'Barcode Attachments'
              ];
              this.gridColumns = gridColumns.sort();
              if (userPreference[key]) {
                switch (key) {
                  case 'product':
                    this.selectedColumns.push('Product name');
                    break;
                  case 'registrationType':
                    this.selectedColumns.push('Version');
                    break;
                  case 'device_UDI':
                    this.selectedColumns.push('Model name');
                    break;
                  case 'barcode':
                    this.selectedColumns.push('Barcode');
                    break;
                  case 'registration_Number':
                    this.selectedColumns.push('Certification URL');
                    break;
                  case 'country':
                    this.selectedColumns.push('Country of origin');
                    break;
                  case 'company':
                    this.selectedColumns.push('Manufacturer');
                    break;
                  case 'status':
                    this.selectedColumns.push('Status');
                    break;
                  case 'expiration':
                    this.selectedColumns.push('Expiration');
                    break;
                  case 'local_distributor':
                    this.selectedColumns.push('Brand name');
                    break;
                  case 'device_family':
                    // this.selectedColumns.push('Device family');
                    break;
                  case 'device_type':
                    this.selectedColumns.push('Product type');
                    break;
                  case 'device_class':
                    this.selectedColumns.push('Product class');
                    break;
                  case 'localRepresentative':
                    this.selectedColumns.push('Managed by');
                    break;
                  case 'deviceHardwareVersion':
                    this.selectedColumns.push('Marked input voltage');
                    break;
                  case 'deviceSoftwareVersion':
                    this.selectedColumns.push('Marked input wattage');
                    break;
                  case 'relatedCertificate':
                    this.selectedColumns.push('Related records');
                    break;
                  case 'comments':
                    this.selectedColumns.push('Comments');
                    break;
                  case 'attachments':
                    this.selectedColumns.push('Attachments');
                    break;
                  case 'submissionNumber':
                    this.selectedColumns.push('Certification number');
                    break;
                  case 'archive_reason':
                    this.selectedColumns.push('Archive reason');
                    break;
                  case 'approval_date':
                    this.selectedColumns.push('Approval date');
                    break;
                  case 'record_type':
                    this.selectedColumns.push('Certification mark');
                    break;
                  case 'issued_by':
                    this.selectedColumns.push('Accredited by');
                    break;
                  case 'record_configuration':
                    this.selectedColumns.push('Description');
                    break;
                  case 'standards':
                    this.selectedColumns.push('Standards');
                    break;
                  case 'ordinance':
                    this.selectedColumns.push('Ordinance');
                    break;
                  case 'imported_product':
                    this.selectedColumns.push('Imported Product');
                    break;
                  case 'importer':
                    this.selectedColumns.push('Importer');
                    break;
                  case 'requester':
                    this.selectedColumns.push('Requester');
                    break;
                  case 'trade_representative':
                    this.selectedColumns.push('Trade Representative');
                    break;
                  case 'input_status':
                    this.selectedColumns.push('Input Status');
                    break;
                  case 'test_report':
                    this.selectedColumns.push('Test Report');
                    break;
                  case 'test_report_attachments':
                    this.selectedColumns.push('Test Report Attachments');
                    break;
                  case 'product_certificate':
                    this.selectedColumns.push('Product Certificate');
                    break;
                  case 'product_certificate_attachments':
                    this.selectedColumns.push('Product Certificate Attachments');
                    break;
                  case 'barcodeFile':
                    this.selectedColumns.push('Barcode File');
                    break;
                  case 'barcode_attachments':
                    this.selectedColumns.push('Barcode Attachments');
                    break;
                  default:
                    break;
                }
              }
              this.diffSelectedColumns = [...this.selectedColumns];
            });
          }
          this.certificateCountryList = [];
          this.countryCertificateType = [];
          this.certificateCountryManual = [];
          this.countryCertificateType = countryCertificateAuth;
          countryCertificateAuth.forEach((i) => {
            if (this.certificateCountryList.indexOf(i.country_id) === -1) {
              this.certificateCountryList.push(i.country_name);
              this.certificateCountryManual.push({
                country_name: i.country_name
              });
            }
          });
          this.archiveReasonsList = archivingReasons;
          archivingReasons.forEach((data) => {
            this.selectedArchiveReason.push(data.reason);
          });
        })
      );
    },
    async editColumnPreferences() {
      if ($('#editColumnPreferences').hasClass('angle')) {
        // During focus out
        $('#editColumnPreferences').removeClass('angle');
      }
      const previouslySelectedColumns = [...this.diffSelectedColumns].sort();
      if (!isEqual(this.selectedColumns.sort(), previouslySelectedColumns)) {
        this.isSelectedColumnsChanged = true;
      }
    },

    async updateUserSelctedPreferences() {
      if (this.selectedColumns.length <= 6) {
        const data = {
          product: this.selectedColumns.indexOf('Product name') !== -1,
          device_UDI: this.selectedColumns.indexOf('Model name') !== -1,
          barcode: this.selectedColumns.indexOf('Barcode') !== -1,
          registration_Number: this.selectedColumns.indexOf('Certification URL') !== -1,
          country: this.selectedColumns.indexOf('Country of origin') !== -1,
          status: this.selectedColumns.indexOf('Status') !== -1,
          expiration: this.selectedColumns.indexOf('Expiration') !== -1,
          local_distributor: this.selectedColumns.indexOf('Brand name') !== -1,
          // device_family: this.selectedColumns.indexOf('Device family') !== -1,
          device_type: this.selectedColumns.indexOf('Product type') !== -1,
          device_class: this.selectedColumns.indexOf('Product class') !== -1,
          company: this.selectedColumns.indexOf('Manufacturer') !== -1,
          localRepresentative: this.selectedColumns.indexOf('Managed by') !== -1,
          registrationType: this.selectedColumns.indexOf('Version') !== -1,
          comments: this.selectedColumns.indexOf('Comments') !== -1,
          attachments: this.selectedColumns.indexOf('Attachments') !== -1,
          submissionNumber: this.selectedColumns.indexOf('Certification number') !== -1,
          approval_date: this.selectedColumns.indexOf('Approval date') !== -1,
          record_configuration: this.selectedColumns.indexOf('Description') !== -1,
          issued_by: this.selectedColumns.indexOf('Accredited by') !== -1,
          archive_reason: this.selectedColumns.indexOf('Archive reason') !== -1,
          standards: this.selectedColumns.indexOf('Standards') !== -1,
          ordinance: this.selectedColumns.indexOf('Ordinance') !== -1,
          imported_product: this.selectedColumns.indexOf('Imported Product') !== -1,
          importer: this.selectedColumns.indexOf('Importer') !== -1,
          requester: this.selectedColumns.indexOf('Requester') !== -1,
          trade_representative: this.selectedColumns.indexOf('Trade Representative') !== -1,
          inputStatus: this.selectedColumns.indexOf('Input Status') !== -1,
          test_report: this.selectedColumns.indexOf('Test Report') !== -1,
          product_certificate: this.selectedColumns.indexOf('Product Certificate') !== -1,
          barcodeFile: this.selectedColumns.indexOf('Barcode File') !== -1
        };
        const response = await updateUserPreference(data);
        if (response) {
          this.diffSelectedColumns = [...this.selectedColumns];
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Columns modified successfully!',
            group: 'custom-notification'
          });
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: 'updating Columns !',
            group: 'custom-notification'
          });
        }
        this.isSelectedColumnsChanged = false;
      }
    },

    confirmDeleteRegistrations() {
      this.validateFilterAndGridDataMultiple();
      // checking the selected records/registrations count with max deletion of records count
      if (this.selectedAndFilteredRecords.length > this.max_records_delete) {
        $('#registrationDelete_alert').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        $('#registrationDelete').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    },
    confirmArchiveRegistrations() {
      this.validateFilterAndGridDataMultiple();
      $('#registrationArchive').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async loadRegistrationDataAfterDelete() {
      this.selectedRegistration = [];
      this.refreshDataAfterDeleteRecord = true;
      this.filterRegistration(this.filterKey);
      if (this.gridDataNonArchived.length === 0 && this.gridDataArchived.length === 0) {
        this.disableContent = true;
        this.archivedFlag = false;
      }
    },

    loadSingleRegistrationData(strObj, isArchives = false) {
      strObj.forEach((row) => {
        let expiration = '';
        let expirationDate = '';
        let approvalDate = '';
        let submissionDate = '';
        let revisionDate = '';
        let countryName = '';
        let countryCode = '';
        let inProgressVal = '';
        let salesForceManage = '';
        if (row.status.toLowerCase() === 'pending') {
          expiration = 'N/A';
        } else if (row.doesNotExpireStatus) {
          expiration = 'DNE';
        } else if (row.expiration_date !== '' && row.expiration_date !== null) {
          expiration = moment.utc(row.expiration_date).fromNow();
        } else {
          expiration = 'N/A';
        }
        if (row.doesNotExpireStatus) {
          expirationDate = 'DNE';
        } else if (row.expiration_date !== '' && row.expiration_date !== null) {
          expirationDate = moment.utc(row.expiration_date).format('DD MMM YYYY');
        } else {
          expirationDate = 'N/A';
        }
        if (row.approval_date !== '' && row.approval_date !== null) {
          approvalDate = moment.utc(row.approval_date).format('DD MMM YYYY');
        } else {
          approvalDate = 'N/A';
        }
        if (row.submission_date !== '' && row.submission_date !== null) {
          submissionDate = moment.utc(row.submission_date).format('DD MMM YYYY');
        } else {
          submissionDate = 'N/A';
        }
        if (row.product_family !== '' && row.product_family !== null) {
          revisionDate = moment.utc(row.product_family).format('DD MMM YYYY');
        } else {
          revisionDate = 'N/A';
        }
        if (
          (row.country_name === '' || row.country_name === null) &&
          (row.country_code === '' || row.country_code === null)
        ) {
          countryCode = 'Not Available';
          countryName = 'Not Available';
        } else {
          countryCode = row.country_code;
          countryName = row.country_name;
        }

        if (row.renewal_in_progress || row.modification_in_progress) {
          inProgressVal = 'In Progress';
        } else {
          inProgressVal = '';
        }
        if (row.salesforce_id) {
          salesForceManage = row.salesforce_id;
        } else {
          salesForceManage = 'no';
        }
        const entryOne = {
          id: row.registration_number,
          registrationId: row.registration_id,
          Product: row.product_name,
          Barcode: row.barcode,
          'Record number': row.registration_number,
          Status: row.status.charAt(0).toUpperCase() + row.status.slice(1),
          Expiration: expiration,
          Country: countryName,
          'Device UDI': row.udi,
          'Local distributor': row.distributor_name || '',
          'Device class': row.product_class || '',
          Comments: row.comments,
          certificate: row.certificate,
          standards: row.standards,
          ordinance: row.ordinance,
          test_report: row.test_report,
          product_certificate: row.product_certificate,
          barcodeFile: row.barcodeFile,
          test_report_attachments: row.test_report_attachments,
          product_certificate_attachments: row.product_certificate_attachments,
          barcode_attachments: row.barcode_attachments,
          imported_product: row.imported_product,
          requester: row.requester,
          importer: row.importer,
          trade_representative: row.trade_representative,
          inputStatus: row.inputStatus,
          'Device family': revisionDate,
          'Device type': row.product_type || '',
          'Country Code': countryCode,
          'Expiration Date': expirationDate,
          'Approval date': approvalDate,
          'Submission date': submissionDate,
          rawExpirationDate: row.expiration_date,
          rawApprovalDate: row.approval_date,
          rawSubmissionDate: row.submission_date,
          rawRevisionDate: row.product_family,
          notYetApprovedStatus: row.notYetApprovedStatus,
          doesNotExpireStatus: row.doesNotExpireStatus,
          'Local representative': row.local_representative || '',
          medCompContact: row.medcomp_contact_id ? row.medcomp_contact_name : '',
          attachmentLinks: row.attachmentLinks ? row.attachmentLinks.split(';') : '',
          countryId: row.country_id,
          product_class_id: row.product_class_id,
          statusDescription: row.statusDescription || '',
          Manufacturer: row.registrationCompany,
          alertBeforeMonths: row.alertBeforeMonths,
          Configuration: row.configuration,
          relatedCertificateName: row.related_record,
          relatedCertificateId: row.relatedCertificateId || '',
          registrationType: row.registrationType,
          registrationMinimumRenewalDate: row.registrationMinimumRenewalDate ? row.registrationMinimumRenewalDate : 0,
          registrationRenewalDeadline: row.registrationRenewalDeadline ? row.registrationRenewalDeadline : 0,
          'Submission number': row.submission_number,
          submissionNumber: row.submission_number,
          archiveReasonID: row.archiving_reason_id || null,
          archiveReasonName: row.archivingReasonName || null,
          archivingReasonName: row.archivingReasonName ? row.archivingReasonName : '',
          renewal_in_progress: row.renewal_in_progress ? row.renewal_in_progress : null,
          modification_in_progress: row.modification_in_progress ? row.modification_in_progress : null,
          'In Progress': inProgressVal,
          'Issued by': row.issued_by == null ? '' : row.issued_by,
          'Record type': row.record_type,
          relatedProduct: row.relatedProductName,
          salesForceManaged: salesForceManage
        };
        if (isArchives) {
          const xIndex = this.gridData.findIndex((item) => item.registrationId === row.registration_id);
          if (xIndex > -1) {
            if (row.is_archived) {
              this.gridDataArchived.push(entryOne);
              this.gridDataNonArchived.splice(xIndex, 1);
            } else {
              this.gridDataArchived.splice(xIndex, 1);
              this.gridDataNonArchived.push(entryOne);
            }
          }
          const globalRegistrationIndex = this.gridDataArchivedAndNonArchived.findIndex(
            (item) => item.registrationId === row.registration_id
          );
          if (globalRegistrationIndex > -1) {
            this.gridDataArchivedAndNonArchived.splice(globalRegistrationIndex, 1, entryOne);
          }
        } else {
          this.gridDataArchivedAndNonArchived.push(entryOne);
          this.gridDataNonArchived.push(entryOne);
        }
      });
    },
    async loadRegistrationDataafterAdd(valObj) {
      if (valObj && this.gridData.length > 0) {
        this.loadSingleRegistrationData(valObj.saveAllData);
      } else {
        this.loaderStatus = true;
        this.gridDataNonArchived = [];
        this.gridDataArchived = [];
        this.gridDataArchivedAndNonArchived = [];
        this.girdChunkData = [];
        this.gridData = [];
        this.filterRegistration(this.filterKey);
      }
    },
    async loadRegistrationDataafterEditpayload(valObj) {
      const xIndex = this.gridData.findIndex((item) => item.registrationId === valObj.registrationId);
      if (xIndex !== -1) this.gridData.splice(xIndex, 1, valObj);

      const globalRegistrationIndex = this.gridDataArchivedAndNonArchived.findIndex(
        (item) => item.registrationId === valObj.registrationId
      );
      if (globalRegistrationIndex > -1) {
        this.gridDataArchivedAndNonArchived.splice(globalRegistrationIndex, 1, valObj);
      }
      this.gridDataFunction();
    },
    async loadRegistrationDataafterArchive(valObj) {
      // this.loadRegistrationDataAfterCancel();
      this.loadSingleRegistrationData(valObj, true);
      this.selectedRegistration = [];
      this.refreshDataAfterDeleteRecord = true;
      this.filterRegistration(this.filterKey);
    },

    async loadRegistrationData() {
      this.tableLoader = true;
      this.loaderStatus = false;
      if ((this.gridDataNonArchived.length === 0 && this.gridDataArchived === 0) || this.loadAfterSubmit) {
        this.importProgressStatus = true;
      }
      const payload = {
        pageNum: this.currentPage,
        pageSize: this.perPage,
        statusId: this.statusId,
        countryName: this.countryName,
        isSaveDraft: this.isSaveDraft,
        isArchived: this.isArchived,
        startDate: this.startDate,
        endDate: this.endDate,
        searchValue: this.registrationSearch ? this.registrationSearch : null,
        dashboardType: this.complianceQuery ? this.complianceQuery : null
      };
      const result = await getRegistrationDetailsByPagination(payload);
      const registrationsData = result.data;
      this.searchResultCount = result.count;
      this.totalPages = Math.ceil(this.searchResultCount / this.perPage) ? Math.ceil(this.searchResultCount / this.perPage) : 1;
      this.currentPage = this.currentPage > this.totalPages ? this.totalPages : this.currentPage;
      this.totalRecordsData = [...registrationsData];
      this.tableLoader = false;
      let registrations = [];
      if (this.complianceQuery) {
        const summary = await getDashboardSummary();
        const range = this.complianceQuery;
        this.expiration_details = summary.expiration_details[range].products;
        const ids = this.expiration_details.map((obj) => obj.rid);
        registrations = registrationsData.filter((reg) => ids.includes(reg.registration_id));
        this.compliance = true;
      } else {
        registrations = registrationsData;
      }
      if (registrations.length) {
        this.gridData = [];
        this.gridDataProgress = [];
        let expiration = '';
        let expirationDate = '';
        let approvalDate = '';
        let submissionDate = '';
        let revisionDate = '';
        let nextMaintenanceDate = '';
        let countryName = '';
        let countryCode = '';
        let inProgressVal = '';
        let salesForceManage = '';
        registrations.forEach((row) => {
          if (row.status.toLowerCase() === 'pending') {
            expiration = 'N/A';
          } else if (row.doesNotExpireStatus) {
            expiration = 'DNE';
          } else if (row.expiration_date !== '' && row.expiration_date !== null) {
            expiration = moment.utc(row.expiration_date).fromNow();
          } else {
            expiration = 'N/A';
          }
          if (row.doesNotExpireStatus) {
            expirationDate = 'DNE';
          } else if (row.expiration_date !== '' && row.expiration_date !== null) {
            expirationDate = moment.utc(row.expiration_date).format('DD MMM YYYY');
          } else {
            expirationDate = 'N/A';
          }
          if (row.approval_date !== '' && row.approval_date !== null) {
            approvalDate = moment.utc(row.approval_date).format('DD MMM YYYY');
          } else {
            approvalDate = 'N/A';
          }
          if (row.submission_date !== '' && row.submission_date !== null) {
            submissionDate = moment.utc(row.submission_date).format('DD MMM YYYY');
          } else {
            submissionDate = 'N/A';
          }
          if (row.product_family !== '' && row.product_family !== null) {
            revisionDate = moment.utc(row.product_family).format('DD MMM YYYY');
          } else {
            revisionDate = 'N/A';
          }
          if (row.next_maintenance_date !== '' && row.next_maintenance_date !== null) {
            nextMaintenanceDate = moment.utc(row.next_maintenance_date).format('DD MMM YYYY');
          } else {
            nextMaintenanceDate = 'N/A';
          }
          if (
            (row.country_name === '' || row.country_name === null) &&
            (row.country_code === '' || row.country_code === null)
          ) {
            countryCode = 'Not Available';
            countryName = 'Not Available';
          } else {
            countryCode = row.country_code;
            countryName = row.country_name;
          }

          if (row.renewal_in_progress || row.modification_in_progress) {
            inProgressVal = 'In Progress';
          } else {
            inProgressVal = '';
          }
          if (row.salesforce_id) {
            salesForceManage = row.salesforce_id;
          } else {
            salesForceManage = 'no';
          }
          const entry = {
            id: row.registration_number,
            registrationId: row.registration_id,
            Product: row.product_name,
            Barcode: row.barcode,
            'Record number': row.registration_number,
            Status: row.status.charAt(0).toUpperCase() + row.status.slice(1),
            Expiration: expiration,
            Country: countryName,
            'Device UDI': row.udi,
            'Local distributor': row.distributor_name || '',
            'Device class': row.product_class || '',
            Comments: row.comments,
            certificate: row.certificate,
            standards: row.standards,
            ordinance: row.ordinance,
            test_report: row.test_report,
            product_certificate: row.product_certificate,
            barcodeFile: row.barcodeFile,
            test_report_attachments: row.test_report_attachments,
            product_certificate_attachments: row.product_certificate_attachments,
            barcode_attachments: row.barcode_attachments,
            imported_product: row.imported_product,
            requester: row.requester,
            importer: row.importer,
            trade_representative: row.trade_representative,
            inputStatus: row.inputStatus,
            'Device family': revisionDate,
            'Device type': row.product_type || '',
            'Country Code': countryCode,
            'Expiration Date': expirationDate,
            'Approval date': approvalDate,
            'Submission date': submissionDate,
            'Maintenance date': revisionDate,
            'Next maintenance date': nextMaintenanceDate,
            rawExpirationDate: row.expiration_date,
            rawApprovalDate: row.approval_date,
            rawSubmissionDate: row.submission_date,
            rawRevisionDate: row.product_family,
            notYetApprovedStatus: row.notYetApprovedStatus,
            doesNotExpireStatus: row.doesNotExpireStatus,
            'Local representative': row.local_representative || '',
            medCompContact: row.medcomp_contact_id ? row.medcomp_contact_name : '',
            attachmentLinks: row.attachmentLinks ? row.attachmentLinks.split(';') : '',
            countryId: row.country_id,
            product_class_id: row.product_class_id,
            statusDescription: row.statusDescription,
            Manufacturer: row.registrationCompany,
            alertBeforeMonths: row.alertBeforeMonths,
            Configuration: row.configuration,
            relatedCertificateName: row.related_record,
            relatedCertificateId: row.relatedCertificateId,
            registrationType: row.registrationType,
            registrationMinimumRenewalDate: row.registrationMinimumRenewalDate,
            registrationRenewalDeadline: row.registrationRenewalDeadline,
            'Submission number': row.submission_number,
            submissionNumber: row.submission_number,
            archiveReasonID: row.archiving_reason_id,
            archiveReasonName: row.archivingReasonName,
            archivingReasonName: row.archivingReasonName ? row.archivingReasonName : '',
            renewal_in_progress: row.renewal_in_progress,
            modification_in_progress: row.modification_in_progress,
            'In Progress': inProgressVal,
            'Issued by': row.issued_by == null ? '' : row.issued_by,
            'Record type': row.record_type,
            salesForceManaged: salesForceManage,
            resolve: row.resolve,
            isNewToMarket: row.isNewToMarket,
            save_draft: row.save_draft,
            maintenanceDocuments: row.maintenance_attachments,
            is_able_to_renew: row.is_able_to_renew,
            registrationTypeId: row.registrationTypeId
          };
          this.gridData.push(entry);
        });
        this.importProgressStatus = false;
        this.enableRecordLoader = false;
        this.enableCheckAll = true;
      }
    },
    async loadInvalidRegistrationData(dataList = []) {
      this.tableLoader = true;
      const registrationsData = dataList;
      this.totalRecordsData = registrationsData;
      this.tableLoader = false;
      let registrations = [];
      registrations = registrationsData;
      if (registrations.length) {
        this.gridData = [];
        this.gridDataProgress = [];
        this.invalidList = [];
        let expirationDate = '';
        let approvalDate = '';
        let submissionDate = '';
        let revisionDate = '';
        let countryName = '';
        let countryCode = '';
        registrations.forEach((row) => {
          if (row.doesNotExpireStatus) {
            expirationDate = 'DNE';
          } else if (row.expiration_date !== '' && row.expiration_date !== null) {
            expirationDate = moment(row.expiration_date).format('DD MMM YYYY');
          } else {
            expirationDate = 'N/A';
          }
          if (row.issue_date !== '' && row.issue_date !== null) {
            approvalDate = moment(row.issue_date).format('DD MMM YYYY');
          } else {
            approvalDate = 'N/A';
          }
          if (row.submission_date !== '' && row.submission_date !== null) {
            submissionDate = moment(row.submission_date).format('DD MMM YYYY');
          } else {
            submissionDate = 'N/A';
          }
          if (row.revision_date !== '' && row.revision_date !== null) {
            revisionDate = moment(row.revision_date).format('DD MMM YYYY');
          } else {
            revisionDate = 'N/A';
          }
          if (row.country_id === '' || row.country_id === null) {
            countryCode = 'Not Available';
            countryName = 'Not Available';
          } else if (row.country_id) {
            const countryDetails = this.countryListFilter.find((country) => country.id === row.country_id);
            countryCode = countryDetails.code;
            countryName = countryDetails.name;
          }
          const entry = {
            id: row.id,
            registrationId: row.id,
            Product: row.product_name,
            Barcode: row.barcode,
            'Record number': row.certification_number,
            Status: row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '',
            Expiration: expirationDate,
            Country: countryName,
            'Device UDI': row.model_name || '',
            'Local distributor': row.brand_name || '',
            'Device class': row.product_class_id || '',
            Comments: row.comments,
            certificate: row.certification_number,
            standards: row.standards,
            ordinance: row.ordinance,
            test_report: row.test_report || '',
            product_certificate: row.product_certificate,
            barcodeFile: row.barcodeFile,
            test_report_attachments: row.test_report_attachments,
            product_certificate_attachments: row.product_certificate_attachments,
            barcode_attachments: row.barcode_attachments,
            imported_product: row.imported_product,
            requester: row.requester,
            importer: row.importer,
            trade_representative: row.trade_representative,
            inputStatus: row.inputStatus,
            'Device family': revisionDate,
            'Device type': row.product_type || '',
            'Country Code': countryCode,
            'Expiration Date': expirationDate,
            'Approval date': approvalDate,
            'Submission date': submissionDate,
            nextMaintenanceDate: moment(row.next_maintenance_date).format('DD MMM YYYY'),
            rawExpirationDate: expirationDate,
            rawApprovalDate: approvalDate,
            rawSubmissionDate: submissionDate,
            rawRevisionDate: revisionDate,
            notYetApprovedStatus: row.notYetApprovedStatus,
            doesNotExpireStatus: row.doesNotExpireStatus,
            'Local representative': row.managed_by || '',
            managedBy: row.managed_by,
            medCompContact: row.medcomp_contact_id ? row.medcomp_contact_name : '',
            attachmentLinks: row.attachmentLinks ? row.attachmentLinks.split(';') : '',
            countryId: row.country_id,
            product_class_id: row.product_class_id,
            statusDescription: row.statusDescription,
            Manufacturer: row.manufacturer,
            plantLocationId: row.plant_location_id,
            alertBeforeMonths: row.alert_date,
            Configuration: row.description,
            relatedCertificateName: row.related_record,
            relatedCertificateId: row.relatedCertificateId,
            registrationType: row.product_category_id,
            registrationMinimumRenewalDate: row.registrationMinimumRenewalDate,
            registrationRenewalDeadline: row.registrationRenewalDeadline,
            'Submission number': row.certification_number,
            submissionNumber: row.certification_number,
            certificationURL: row.certification_url,
            archiveReasonID: row.archiving_reason_id,
            archiveReasonName: row.archivingReasonName,
            archivingReasonName: row.archivingReasonName ? row.archivingReasonName : '',
            renewal_in_progress: row.renewal_in_progress,
            modification_in_progress: row.modification_in_progress,
            'In Progress': '',
            'Issued by': row.accredited_by_id,
            'Record type': row.record_type,
            salesForceManaged: '',
            resolve: row.resolve,
            isNewToMarket: row.isNewToMarket,
            save_draft: row.save_draft,
            'Maintenance date': row.product_family,
            'Next maintenance date': moment(row.next_maintenance_date).format('DD MMM YYYY'),
            registrationTypeId: row.registrationTypeId
          };
          if (row.is_duplicated) entry.error = this.$i18n.locale === 'Portuguese' ? 'Registro duplicado' : 'Duplicate record';
          else if (row.is_required_fields_missing) entry.error = this.$i18n.locale === 'Portuguese' ? 'Informação faltando' : 'Missing Information';
          else entry.error = this.$i18n.locale === 'Portuguese' ? 'Dados inválidos' : 'Invalid Input';
          this.invalidList.push(entry);
        });
        this.gridData = this.invalidList;
        this.importProgressStatus = false;
      } else {
        this.importProgressStatus = false;
        this.enableRecordLoader = false;
        this.enableCheckAll = true;
      }
      this.loaderStatus = false;
    },
    moment(date) {
      return moment.utc(date);
    },
    gridColumnStatus(value) {
      for (let i = 0; i < this.selectedColumns.length; i += 1) {
        if (this.selectedColumns[i] === value) {
          return true;
        }
      }
      return false;
    },

    resetSearch() {
      this.registrationSearch = '';
    },

    async filterRegistration(val) {
      this.activeId = new Set();
      this.regHeaderActiveName = val;
      this.filterKey = val;
      if (val === 'View All') {
        this.archivedFlag = false;
        this.loaderStatus = true;
        this.gridDataNonArchived = [];
        this.gridData = [];
        this.gridDataArchived = [];
        this.statusId = [1, 2, 3, 4, 5];
        this.isArchived = false;
        this.isSaveDraft = false;
        await this.loadRegistrationData();
        this.loaderStatus = false;
      } else if (val === 'Expired') { // for tabs we need static StatusID since this recurrence block
        this.archivedFlag = false;
        this.loaderStatus = true;
        this.gridDataNonArchived = [];
        this.gridData = [];
        this.gridDataArchived = [];
        this.statusId = [4];
        this.isArchived = false;
        this.isSaveDraft = false;
        await this.loadRegistrationData();
        this.loaderStatus = false;
      } else if (val === 'Action Needed') { // for tabs we need static StatusID since this recurrence block
        this.archivedFlag = false;
        this.loaderStatus = true;
        this.gridDataNonArchived = [];
        this.gridData = [];
        this.gridDataArchived = [];
        this.isArchived = false;
        this.isSaveDraft = false;
        this.statusId = [3, 5];
        await this.loadRegistrationData();
        this.loaderStatus = false;
      } else if (val === 'Pending') { // for tabs we need static StatusID since this recurrence block
        this.archivedFlag = false;
        this.loaderStatus = true;
        this.gridDataNonArchived = [];
        this.gridData = [];
        this.gridDataArchived = [];
        this.isArchived = false;
        this.isSaveDraft = false;
        this.statusId = [2];
        await this.loadRegistrationData();
        this.loaderStatus = false;
      } else if (val === 'Active') { // for tabs we need static StatusID since this recurrence block
        this.archivedFlag = false;
        this.loaderStatus = true;
        this.gridDataNonArchived = [];
        this.gridData = [];
        this.gridDataArchived = [];
        this.isArchived = false;
        this.isSaveDraft = false;
        this.statusId = [1];
        await this.loadRegistrationData();
        this.loaderStatus = false;
      } else if (val === 'Archive') { // for tabs we need static StatusID since this recurrence block
        this.archivedFlag = true;
        this.loaderStatus = true;
        this.gridData = [];
        this.statusId = [1, 2, 3, 4, 5];
        this.isArchived = true;
        this.isSaveDraft = false;
        await this.loadRegistrationData();
        this.loaderStatus = false;
      } else if (val === 'Draft') { // for tabs we need static StatusID since this recurrence block
        this.archivedFlag = false;
        this.loaderStatus = true;
        this.gridData = [];
        this.statusId = [1, 2, 3, 4, 5];
        this.isSaveDraft = true;
        this.isArchived = false;
        await this.loadRegistrationData();
        this.loaderStatus = false;
      } else if (val === 'Invalid Records') {
        this.loaderStatus = true;
        const payload = {
          pageNum: this.currentPage,
          pageSize: this.perPage,
          statusId: [1, 2, 3, 4, 5],
          countryName: this.countryName,
          startDate: null,
          endDate: null,
          searchValue: this.registrationSearch ? this.registrationSearch : null,
        };
        const result = await getInvalidRecords(payload);
        const res = result.data;
        this.searchResultCount = result.count;
        this.totalPages = Math.ceil(this.searchResultCount / this.perPage) ? Math.ceil(this.searchResultCount / this.perPage) : 1;
        this.currentPage = this.currentPage > this.totalPages ? this.totalPages : this.currentPage;
        this.invalidList = [];
        if (res && res.length) this.loadInvalidRegistrationData(res);
        else this.invalidList = [];
        this.gridData = this.invalidList;
        this.loaderStatus = false;
      } else {
        this.archivedFlag = false;
        this.gridData = this.gridDataNonArchived;
      }
      this.$emit('checkFalse', 0);
    },
    selectedRegistrationListChanged(changedList) {
      this.selectedRegistration = changedList;
      this.validateFilterAndGridDataMultiple();
    },
    selectedRegistrationListDeleted(deletedListFlag) {
      this.refreshDataAfterDeleteRecord = deletedListFlag;
    },
    filteredRegistrationsLength(result) {
      this.filteredRegistrationsCount = result;
    },
    pdfExport() {
      EventBus.$emit('pdfExport', true);
    },
    updateRegistrationAttachment(valObj) {
      const index = this.gridDataNonArchived.findIndex((item) => item.registrationId === valObj.registrationId);
      if (index > -1) {
        const record = CloneDeep(this.gridDataNonArchived[index]);
        record.attachmentLinks = valObj.attachmentLinks ? valObj.attachmentLinks.split(';') : [];
        this.gridDataNonArchived.splice(index, 1, record);
      }

      const xIndex = this.gridData.findIndex((item) => item.registrationId === valObj.registrationId);
      if (xIndex > -1) {
        const record = CloneDeep(this.gridData[xIndex]);
        record.attachmentLinks = valObj.attachmentLinks ? valObj.attachmentLinks.split(';') : [];
        this.gridData.splice(xIndex, 1, record);
      }

      const globalRegistrationIndex = this.gridDataArchivedAndNonArchived.findIndex(
        (item) => item.registrationId === valObj.registrationId
      );

      if (globalRegistrationIndex > -1) {
        const record = CloneDeep(this.gridDataArchivedAndNonArchived[globalRegistrationIndex]);
        record.attachmentLinks = valObj.attachmentLinks ? valObj.attachmentLinks.split(';') : [];
        this.gridDataArchivedAndNonArchived.splice(globalRegistrationIndex, 1, record);
      }
      this.gridDataFunction();
    }
  },
  async created() {
    // window.addEventListener('beforeunload', () => {
    //   this.$router.push('/layout/registration');
    // });
    // window.addEventListener('changeSubscriptionPopup', () => {
    // console.log('created ');
    // });
    this.loadColumnPreferences();
    this.getCountryList();
    if (this.$route.params.searchRegistration) {
      this.registrationSearch = this.$route.params.searchRegistration;
    }
    if (this.$route.params.filterRegistration) {
      this.filterRegistration(this.$route.params.filterRegistration);
    } else if (localStorage.getItem('tabSelected')) {
      this.regMenuSelected(localStorage.getItem('tabSelected'));
    } else {
      this.filterRegistration('View All');
    }
    EventBus.$on('loadRegistrationData', () => {
      this.loadRegistrationData();
    });
    EventBus.$on('loadRegistrationDataafterAdd', async () => {
      this.gridDataNonArchived = [];
      this.gridDataArchived = [];
      this.girdChunkData = [];
      await this.filterRegistration(this.filterKey);
    });

    EventBus.$on('loadRegistrationDataafterEdit', (data) => {
      this.loadRegistrationDataafterEditpayload(data);
    });
    socket.on(`alertGetRegistrationDetails_${localStorage.getItem('userId')}`, (data) => {
      this.importPercentage = data;
    });
    EventBus.$on('bulkUpload', (data) => {
      if (data.disableAdd) {
        this.disableAdd = true;
      } else {
        this.disableAdd = false;
      }
    });
    EventBus.$on('updateRegistrationAttachment', (data) => {
      this.updateRegistrationAttachment(data);
    });
  },
  async mounted() {
    this.subscriptions = await getSubscriptions(true);
    $('#editColumnPreferences').on('hidden.bs.dropdown', this.editColumnPreferences);
    $('[data-toggle="tooltip"]').tooltip();
    // this.loadRegistrationData();
    $('#editColumnPreferences').click(() => {
      if (!$('#editColumnPreferences').hasClass('open')) {
        $('#editColumnPreferences').addClass('angle');
      } else $('#editColumnPreferences').removeClass('angle');
    });
    if (localStorage.getItem('triggerSubScriptionPopup') === 'true') {
      $('#subscriptionPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
      localStorage.setItem('triggerSubScriptionPopup', 'false');
    }
  },
  beforeDestroy() {
    socket.removeAllListeners(`alertGetRegistrationDetails_${localStorage.getItem('userId')}`);
    EventBus.$off('loadRegistrationData');
    EventBus.$off('loadRegistrationDataafterAdd');
    EventBus.$off('loadRegistrationDataafterEdit');
    EventBus.$off('upgradeRecords');
    EventBus.$off('bulkUpload');
    EventBus.$off('updateRegistrationAttachment');
    EventBus.$off('updateRegWatch');
  }
};
</script>

<style scoped>
.bn-pagination {
  display: block;
  position: relative;
  background-color: #ffffff;
  margin-top: -20px;
}

.pagination-item>button.side-navigation {
  background: green !important;
}
.custom-tooltip-record >>> .excel-popover {
  left: 18px !important;
  width:520px;
  top:60px !important;
  background: #ffffff !important;
}
.custom-tooltip-record >>> .popover-field-name {
  color:#000001 !important;
}

  .custom-tooltip-record >>> .popover-text {
    background: #ffffff !important;
    color: #000001;

}

.custom-tooltip-record >>> .excel-popover:after {
  left:19.8%;
  border-bottom: 10px solid #ffffff

}
.tooltip-left >>> .excel-popover:after {
  left:22.5% !important;
}

.cursor_default img.info-img {
  opacity: 0.4;
}
.btn-disabled,
.btn-disabled:hover {
  border: none;
  background: #ffffff;
  color: #b00505;
}
.deselect-buttons {
  font-size: 18px;
  font-weight: 700;
  padding: 0px;
}
.ml-8 {
  margin-left: 8px;
}
.ml-4 {
  margin-left: 4px;
}
.deselect-button-color,
.deselect-button-color:hover {
  color: #01518a !important;
}
.delete-button-color {
  /* padding-left: 17px; */
  cursor: pointer;
  margin-left: 17px;
  color: #b00505;
}
.search-outer {
  padding-left: 10px;
  /* padding-right: 9px; */
}
.margin-btn-plus-icon {
  margin-top: 1px;
}
/* .download-btn-plus-icon {
  margin-top: 5px;
  vertical-align: top;
  margin-right: 5px;
} */
.label-registration {
  margin-bottom: 0px;
}
.product_records {
  color: #333333;
  padding-top: 9px;
  padding-left: 10px;
  font-weight: 300;
  font-size: 36px;
  line-height: 49px;
}
.pb-24 {
  padding-bottom: 24px;
}

.add-record-parent {
  /* padding: 45px 39px 24px 0px; */
  padding-top: 17px;
  padding-right: 24px;
}
.pl-25 {
  padding-left: 25px;
}
.pr-24 {
  padding-right: 24px;
}

.mb-13 {
  margin-bottom: 13px;
}

.new_record_button,
.new_record_button[disabled],
.new_record_button:hover,
.new_record_button:focus {
  background-color: #01518A;
  border: 1px solid #01518A;
  box-sizing: border-box;
  border-radius: 5px;
  color: #ffffff;
  font-weight: 600;
  font-size: 18px;
  font-family: 'Open Sans';
  line-height: 24px;
  padding: 6px 16px;
  height: 40px;
  min-width: 160px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
}

#search_box {
  border-radius: 4px;
  border: 1px solid #c1c3c6;
}

.reg-search .vertical-line {
  top: 7px;
  right: 35px;
  position: absolute;
  border-left: 1px solid #dfe1e5;
  height: 66%;
}
.reg-search .search-box {
  padding: 0px 12px;
}
.reg-search .search-reset {
  top: 7px;
  right: 45px;
}
.reg-search .p-absolute {
  top: 5px;
  position: absolute;
  right: 10px;
}
/* .default_border {
  border-bottom: 4px solid #fafafa;
} */
.record-stats-wrapper {
  position: relative;
}
.record-countloader {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  margin: 0 auto;
}
.search-input .record-countloader {
  position: absolute;
  width: 15px;
  height: 15px;
  text-align: center;
  margin: 0 auto;
  right: 65px;
  top: 4px;
}
.record-stats {
  opacity: 0.2;
}

/*V2*/
#editColumnPreferences.dropdown.angle.open::before {
  display: unset;
  position: absolute;
  pointer-events: none;
  content: '';
  visibility: visible;
  transform: rotate(45deg);
  width: 21px;
  height: 34px;
  background: #fff;
  z-index: 1;
  right: 12px;
  top: 22px;
  box-shadow: 0 0 6px 1px rgba(41, 38, 38, 0.15);
}

.plus-icon {
  position: relative;
  left: -8px;
  top: -3px;
}
.header-img-size {
  margin-right: 5px;
  height: 17px;
  width: 18px;
  vertical-align: sub;
}
.header-font {
  margin-left: 3px;
  font-size: 16px;
  line-height: 19px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
}
i.fa.fa-exclamation-triangle {
  color: #db2828;
}
.container input[type='checkbox'] {
  display: none;
}
.status-tabs span img {
  width: 18px;
  height: 18px;
  vertical-align: sub;
}
.dropdown_list_li_padding {
  padding: 0px 7px;
}
.new-dropdown-class {
  right: 0;
  left: -12.2em;
  overflow: auto;
  top: 28px;
  margin-left: 10px;
}
.label-expiring-soon {
  padding-right: 0px !important;
}
.expiring-soon-tab {
  padding: 0px !important;
}
.cursor_pointer {
  cursor: pointer;
}
.cursor_default {
  cursor: default;
}
.record_align {
  vertical-align: middle;
}
.menu-header {
  padding: 15px 24px 0px 15px;
  background: #ffffff;
}
.sub_menu {
  background: #ffffff;
  /* margin-top: -7px; */
  padding: 26px 26px 36px 26px;
}
.header-img-size {
  margin-right: 5px;
  height: 18px;
  width: 18px;
  vertical-align: top;
  margin-top: 2px;
}
.export-link,
.export-link:hover {
  color: #0b3c61;
  font-size: 16px;
}
.export-link .header-img-size {
  margin-top: 1px;
}
.un-archive-link,
.archive-link {
  font-size: 16px;
  color: #464646;
}

.header-wrapper,
.section-wrapper {
  padding: 24px;
}

.header-wrapper {
  padding-bottom: 0;
}

.section-wrapper {
  padding-top: 0;
}

.delete-link {
  color: #b00505;
  font-size: 16px;
}
.delete-link:hover {
  color: #b00505;
}

.dashboard-container {
  height: calc(100vh - 50px);
  overflow-y: auto;
  background: #ebebeb;
}

.col-gap-8 {
  column-gap: 8px;
}

/* .emergo-primary-button,
a.emergo-primary-button,
.emergo-primary-button[disabled] {
  background-color: #01518a;
  border: 1px solid #01518a;
  box-sizing: border-box;
  border-radius: 3px;
  color: #f2f2f2;
  font-weight: 500;
  font-size: 18px;
  font-family: Roboto;
  line-height: 21px;
  padding: 6px 15px;
}

.emergo-primary-button:hover:not(:disabled),
.emergo-primary-button:active:hover:not(:disabled) {
  background: #00518a;
  border-color: #00518a;
  color: #f2f2f2;
  box-shadow: none;
}

.emergo-primary-button:active,
.emergo-primary-button:active:focus,
.emergo-primary-button:focus,
.emergo-primary-button:active.focus {
  background: #01518a;
  border-color: #01518a;
  color: rgba(242, 242, 242, 0.5);
  box-shadow: none;
} */
@media screen and (max-width: 1024px) {
  .box {
    min-height: 340px;
  }
  .column-tracker {
    width: 180px;
  }
}

@media screen and (min-width: 412px) and (max-width: 823px) {
  .box {
    min-height: 270px;
  }
}
@media screen and (min-width: 1025px) and (max-width: 1462px) {
  .box {
    min-height: 290px;
  }
}
@media screen and (width: 768px) {
  .new_record_button {
    min-width: auto;
  }
}
@media screen and (max-width: 767px) {
  .flex-buttons {
    display: flex;
    justify-content: space-between;
  }

  .xs-hide {
    display: none;
  }
}

/* .dashboard-container {
  height: 100vh;
  overflow-y: auto;
  background: #ebebeb;
} */

.archive-btn,
.archive-btn:hover {
  color: #01518a !important;
}

.delete-btn,
.delete-btn:hover {
  color: #b00505;
}

.archive-btn,
.delete-btn {
  background: transparent;
}

.header-text {
  font-size: 24px;
  line-height: 34px;
  color: #3e3e3e;
}

.p-relative {
  position: relative;
}
/* .bg-light {
  background: #fafafa;
} */
.container .checkmark:after {
  top: 2px;
}
@media screen and (min-width: 1301px) and (max-width: 1366px) {
  .new_record_button,
  .new_record_button[disabled],
  .new_record_button:hover {
    min-width: 150px;
  }
}
</style>
